import axios from 'axios';
import { defineStore } from 'pinia';
import { authStore } from './auth';

export const noteOfInterestStore = defineStore('noteofinterest-store', {
    state: () => {
        return {
            allNotes: null,
        };
    },
    getters: {
        notes(state) {
            return state.allNotes;
        },
    },

    actions: {
        async fetchAllNotes() {
            try {
                const response = await axios.get(
                    process.env.VUE_APP_API_BASE_URL +
                        'applicants/me/noteOfInterests',
                    authStore().authConfig
                );
                this.allNotes = response.data;
                return true;
            } catch (err) {
                this.allNotes = [];
                console.error('error loading notes: ', err);
                return err;
            }
        },
    },
});
